const n = "_wrapper_17nor_1", t = "_title_17nor_7", o = "_numberOfStations_17nor_12", e = "_explanation_17nor_19", r = "_icon_17nor_23", _ = {
  wrapper: n,
  title: t,
  numberOfStations: o,
  explanation: e,
  icon: r
};
export {
  _ as default,
  e as explanation,
  r as icon,
  o as numberOfStations,
  t as title,
  n as wrapper
};
